import ActionTypes from '../constants/ActionTypes';

/* Events */

export const fetchAllDevicesRequested = () => ({
  type: ActionTypes.ALL_DEVICES_FETCH_REQUESTED,
  payload: {},
});

export const fetchAllDevicesSucceeded = (devices, included) => ({
  type: ActionTypes.ALL_DEVICES_FETCH_SUCCEEDED,
  payload: {
    devices,
    included,
  },
});

export const fetchAllDevicesFailed = (error) => ({
  type: ActionTypes.ALL_DEVICES_FETCH_FAILED,
  payload: {
    error,
  },
});

export const updateItemsDeviceReceived = (items) => ({
  type: ActionTypes.DEVICE_ITEMS_UPDATE_RECEIVED,
  payload: {
    items,
  },
});

export const fetchRealtimeDatasRequested = () => ({
  type: ActionTypes.DATAS_REALTIME_FETCH_REQUESTED,
  payload: {},
});

export const fetchRealtimeDatasSucceeded = (items) => ({
  type: ActionTypes.DATAS_REALTIME_FETCH_SUCCEEDED,
  payload: {
    items,
  },
});

export const fetchRealtimeDatasFailed = (error) => ({
  type: ActionTypes.DATAS_REALTIME_FETCH_FAILED,
  payload: {
    error,
  },
});
